/**
 * Font stacks for Orbit application
 * Lato (display) and Yantramanav (body) are bundled from @fontsource, imported at the app entry;
 * mono is the platform's own for codes, ids and raw values.
 */

export const fonts = {
	display: "'Lato', system-ui, -apple-system, sans-serif",
	body: "'Yantramanav', 'Lato', system-ui, sans-serif",
	mono: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
} as const

export const { display: fontDisplay, body: fontBody, mono: fontMono } = fonts
